import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "hideMessaging"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { usePopoverConfig } from '@infl-ts/util-popover-config';
import { DisplayQueryError } from '@infl-ts/util-query-errors';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { constVoid, flow, pipe } from 'fp-ts/function';
import * as L from 'monocle-ts/Lens';
import { Popover } from '../popover';
import LoadingProfilePopover from './loading';
import PopoverContent from './popover-content';
import { useProfilePopoverMember } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";

var useProps = function useProps(_ref) {
  var id = _ref.id,
      _ref$hideMessaging = _ref.hideMessaging,
      hideMessaging = _ref$hideMessaging === void 0 ? false : _ref$hideMessaging,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _usePopoverConfig = usePopoverConfig(),
      messagingEnabled = _usePopoverConfig.messagingEnabled;

  return _objectSpread({
    memberData: useProfilePopoverMember({
      variables: {
        memberId: id
      }
    }),
    hideMessaging: hideMessaging,
    messagingEnabled: messagingEnabled
  }, rest);
}; // TODO: Remove in ADVO2-2287


var updateMemberId = pipe(L.id(), L.prop('member'), L.prop('id'), L.modify(function (id) {
  return id.replace('member_', '');
}));

var PureProfilePopover = function PureProfilePopover(_ref2) {
  var memberData = _ref2.memberData,
      _ref2$canViewProfile = _ref2.canViewProfile,
      canViewProfile = _ref2$canViewProfile === void 0 ? true : _ref2$canViewProfile,
      hideMessaging = _ref2.hideMessaging,
      messagingEnabled = _ref2.messagingEnabled,
      children = _ref2.children,
      _ref2$onViewProfile = _ref2.onViewProfile,
      onViewProfile = _ref2$onViewProfile === void 0 ? constVoid : _ref2$onViewProfile,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      containerSx = _ref2.containerSx,
      clickAwayMouseEvent = _ref2.clickAwayMouseEvent,
      _ref2$keepMounted = _ref2.keepMounted,
      keepMounted = _ref2$keepMounted === void 0 ? true : _ref2$keepMounted,
      popoverZIndex = _ref2.popoverZIndex;
  return /*#__PURE__*/_jsx(Popover, {
    enablePortal: true,
    disabled: disabled,
    containerSx: containerSx,
    zIndex: popoverZIndex ? popoverZIndex : function (t) {
      return t.zIndex.popover;
    },
    clickAwayMouseEvent: clickAwayMouseEvent,
    keepMounted: keepMounted,
    preventBubbling: true,
    content: function content() {
      return pipe(memberData, DE.map(updateMemberId), DE.refreshFold(function () {
        return /*#__PURE__*/_jsx(Box, {});
      }, function () {
        return /*#__PURE__*/_jsx(LoadingProfilePopover, {});
      }, function (err, refreshing) {
        return /*#__PURE__*/_jsx(DisplayQueryError, {
          err: err,
          refreshing: refreshing,
          message: "Could not load at this time, try again."
        });
      }, function (_ref3) {
        var member = _ref3.member,
            currentUser = _ref3.currentUser;
        var isCurrentUser = member.id === currentUser.id;
        var buttonsVisible = messagingEnabled || currentUser.isAdmin || member.isAdmin;
        return /*#__PURE__*/_jsx(PopoverContent, {
          member: _objectSpread(_objectSpread({}, member), {}, {
            id: isCurrentUser ? currentUser.id : member.id
          }),
          canViewProfile: buttonsVisible && canViewProfile,
          allowMessaging: buttonsVisible && !hideMessaging && !isCurrentUser,
          onViewProfile: onViewProfile
        });
      }));
    },
    "data-element": "Popover",
    "data-component": "PureProfilePopover",
    "data-source-file": "index.tsx",
    children: children
  });
};

export var ProfilePopover = flow(useProps, PureProfilePopover);
export { ProfilePopoverMember } from './queries';